module.exports = __webpack_public_path__ + "static/media/img_2.77d71b80.png";